import { Box, Typography, Grid, LinearProgress, Backdrop, CircularProgress } from "@mui/material";
import { TEXT_TITLE_COLOR } from "../../constants/colors";
import DASHBOARD_CHART_GREEN_ICON from '../../assets/images/dashboard_chart_green_icon.svg';
import DASHBOARD_CHART_BLUE_ICON from '../../assets/images/dashboard_chart_blue_icon.svg';
import DASHBOARD_CHART_ORANGE_ICON from '../../assets/images/dashboard_chart_orange_icon.svg';
import DASHBOARD_CHART_RED_ICON from '../../assets/images/dashboard_chart_red_icon.svg';
import CardSaleReport from "./components/CardSaleReport";
import SwitchComponent from "../../components/switch";
import PRODUCT_MANAGEMENT_ICON from '../../assets/images/drawer_icons/product.svg';
import CATEGORY_MANAGEMENT_ICON from '../../assets/images/drawer_icons/category_management.svg';
import { useNavigate } from "react-router-dom";
import { useHomeController } from "./controller";
import { useTranslation } from "react-i18next";
import { ORDER_ROUTE, SALES_REPORT_ROUTE } from "../../routes/paths";
import CardBranch from "./components/CardBranch";
import { BranchModel } from "../../models/branch";
import { MerChantModel } from "../../models/merChantModel";
import { OrderModel } from "../../models/order";
import LoadingAnimatedIcon from "../../components/loading/loadingAnimated";

const HomeView = () => {
    const navigate = useNavigate();
    const controller = useHomeController();
    const { t, i18n } = useTranslation("global");
    return <Box>
        {
            !controller.loading
                ?
                <Box>
                    <Box>
                        <Typography color={TEXT_TITLE_COLOR} fontWeight="bold"><span style={{ fontSize: 35 }}>{t("saleReport_page.Sale Report")}</span> <span style={{ fontSize: 25 }}>*{controller.todayDate}</span> &nbsp;&nbsp;<span style={{ color: '#11A2F1', cursor: 'pointer' }} onClick={() => navigate(SALES_REPORT_ROUTE)}>{t("saleReport_page.see all")} {'>'}</span></Typography>
                    </Box>
                    <Box mt={5}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={4}>
                                <CardSaleReport title={t("saleReport_page.total sale")} amount={controller.dataOrderReport?.totalSale} icon={DASHBOARD_CHART_GREEN_ICON} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <CardSaleReport title={t("saleReport_page.completed")} amount={controller.dataOrderReport?.completedSale} icon={DASHBOARD_CHART_BLUE_ICON} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <CardSaleReport title={t("saleReport_page.partially completed")} amount={controller.dataOrderReport?.partiallyCompletedSale} icon={DASHBOARD_CHART_ORANGE_ICON} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <CardSaleReport title={t("saleReport_page.return")} amount={controller.dataOrderReport?.returnSale} icon={DASHBOARD_CHART_RED_ICON} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <CardSaleReport title={t("saleReport_page.failed")} amount={controller.dataOrderReport?.failedSale} icon={DASHBOARD_CHART_RED_ICON} />
                            </Grid>
                        </Grid>
                    </Box>
                    <Box mt={5}>
                        <Typography color={TEXT_TITLE_COLOR} fontWeight="bold"><span style={{ fontSize: 35 }}>{t("saleReport_page.My Order")}</span> <span style={{ fontSize: 25 }}>*{controller.todayDate}</span> &nbsp;&nbsp;<span style={{ color: '#11A2F1', cursor: 'pointer' }} onClick={() => navigate(ORDER_ROUTE)}>{t("saleReport_page.see all")} {'>'}</span></Typography>
                    </Box>
                    <Box mt={5}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={4}>
                                <CardSaleReport title={t("saleReport_page.customer order")} amount={controller.dataOrderReport?.customerOrder} icon={DASHBOARD_CHART_GREEN_ICON} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <CardSaleReport title={t("saleReport_page.To pack")} amount={controller.dataOrderReport?.toPackOrder} icon={DASHBOARD_CHART_BLUE_ICON} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <CardSaleReport title={t("saleReport_page.To ship")} amount={controller.dataOrderReport?.toShipOrder} icon={DASHBOARD_CHART_ORANGE_ICON} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <CardSaleReport title={t("saleReport_page.Shipping")} amount={controller.dataOrderReport?.shippingOrder} icon={DASHBOARD_CHART_RED_ICON} />
                            </Grid>
                        </Grid>
                    </Box>
                    <Box mt={5}>
                        <Typography color={TEXT_TITLE_COLOR} fontWeight="bold"><span style={{ fontSize: 35 }}>{t("saleReport_page.Jiffy Branches")}</span> <span style={{ fontSize: 25 }}>*{controller.todayDate}</span> &nbsp;&nbsp;<span style={{ color: '#11A2F1', cursor: 'pointer' }} onClick={() => navigate("/branch")}>{t("saleReport_page.see all")} {'>'}</span></Typography>
                    </Box>
                    <Box mt={5}>
                        <Grid container spacing={2}>
                            {
                                controller?.dataBranch?.map((item: MerChantModel) => {
                                    return <Grid key={item?.id} item xs={12} sm={6} md={4}>
                                        <CardBranch branchName={item?.nameLa} totalSale={controller.calculateTotalWithDeliveryFeeSum(controller.data.filter((subItem: OrderModel) => subItem?.merchantId === item?.id))} />
                                    </Grid>
                                })
                            }

                        </Grid>
                    </Box>
                </Box>
                :
                <Box>
                    <LoadingAnimatedIcon />
                </Box>
        }
    </Box>

}
export default HomeView;